module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ng","http"],"commonjs":"@angular/http","commonjs2":"@angular/http","amd":"@angular/http"}
// module id = 2
// module chunks = 0 1